import { FullPropertyDetails } from '../models';
import { Nullable } from 'common';

export interface PropertySearchDetailsState {
  details: Nullable<FullPropertyDetails>;
  loading: boolean;
}

export const POLICY_INFO_SET_LOADING = 'POLICY_INFO_SET_LOADING';
export const POLICY_INFO_RESULT_SUCCESS = 'POLICY_INFO_RESULT_SUCCESS';
export const RESET_RESULTS = 'RESET_RESULTS';

export const PROPERTY_SEARCH_DETAILS_ADD = 'PROPERTY_SEARCH_DETAILS_ADD';
export const PROPERTY_SEARCH_DETAILS_CLEAR = 'PROPERTY_SEARCH_DETAILS_CLEAR';
export const PROPERTY_SEARCH_DETAILS_LOADING =
  'PROPERTY_SEARCH_DETAILS_LOADING';

export interface PolicyInfoState {
  loading: boolean;
}

export interface SetResultLoadingType {
  type: typeof POLICY_INFO_SET_LOADING;
  loading: boolean;
}

export interface ResetResultsType {
  type: typeof RESET_RESULTS;
}

interface PropertySearchDetailsAddAction {
  type: typeof PROPERTY_SEARCH_DETAILS_ADD;
  payload: FullPropertyDetails;
}

interface PropertySearchDetailsClearAction {
  type: typeof PROPERTY_SEARCH_DETAILS_CLEAR;
}

interface PropertySearchDetailsLoadingAction {
  type: typeof PROPERTY_SEARCH_DETAILS_LOADING;
  payload: boolean;
}

export type PropertySearchDetailsActionTypes =
  | PropertySearchDetailsAddAction
  | PropertySearchDetailsClearAction
  | PropertySearchDetailsLoadingAction;
